import React from 'react'
import SimpleBanner from '../Common/SimpleBanner'
import AboutUs_banner from '../../Assets/About/banaraimg.png'
import TestLaboratory from '../../Components/About/TestLaboratory'
import MissionVision from '../../Components/About/MissionVision'
import SubscribeTo from '../../Components/home/SubscribeTo'
import  LookOurNumbers from '../../Components/About/LookOurNumbers'
const About = () => {
  return (
    <div className='overflow-x-hidden tracking-wide'>
      <SimpleBanner
        image={AboutUs_banner}
        name="About Us"
        path="Home / About us"
      />
      <TestLaboratory/>
      <LookOurNumbers/>
      <MissionVision/>
      <SubscribeTo/>
    </div>
  )
}

export default About
